// The booking PATCH body, the edit modals' submit function and the error text they show.
import { updateBooking } from '../../api/endpoints';

export type UpdateBody = Parameters<typeof updateBooking>[1];
export type SubmitFn = (body: UpdateBody) => Promise<unknown>;

export function extractError(e: unknown): string {
  const anyErr = e as { response?: { data?: { message?: string } } };
  return anyErr?.response?.data?.message || 'Update failed';
}
